import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}
// erp产品列表
export const productQuery = (data: any) =>
  request.post('/erp/web/youka/shop_product/erpSelectPageList', data, jsonHeaderConfig)
// bpm产品列表
export const bpmProductQuery = (data: any) =>
  request.post('/erp/web/youka/shop_product/bpmSelectPageList', data, jsonHeaderConfig)
// erp导出
export const erpExport = '/erp/web/youka/shop_product/erpExport'
// bpm导出
export const bpmExport = '/erp/web/youka/shop_product/bpmExport'

// 新增产品
export const addProduct = (data: any) =>
  request.post('/erp/web/youka/shop_product/addProduct', data, jsonHeaderConfig)
// 修改产品
export const updateProduct = (data: any) =>
  request.post('/erp/web/youka/shop_product/updateProduct', data, jsonHeaderConfig)
// 修改产品状态
export const updateProductStatus = (data: any) =>
  request.post('/erp/web/youka/shop_product/enableAndDisable', data)
// 删除产品
export const deleteProduct = (data: any) =>
  request.post('/erp/web/youka/shop_product/removeById', data)
// 产品详情
export const detailProduct = (data: any) =>
  request.post('/erp/web/youka/shop_product/selectById', data)
// 产品已选进件字段
export const configProduct = (data: any) =>
  request.post('/erp/web/youka/product_material/selectProductMaterialConfig', data)
// 产品所有进件字段
export const configProductAll = (data?: any) =>
  request.post('/erp/web/youka/product_material/selectBaseProductMaterial', data)
// 保存进件字段
export const productFieldSave = (data?: any) =>
  request.post('/erp/web/youka/product_material/saveBaseProductMaterial', data, jsonHeaderConfig)
// 城市
export const getCityList = (data: any) =>
  request.get('/erp/web/youka/bse-province/provinceList', data, jsonHeaderConfig)
// 获取已启用合同模板列表
export const getContractTemplateList = (data?: any) =>
  request.post('/erp/retailContractTemplateManage/getContractTemplateList', data, jsonHeaderConfig)
// 获取预览模板链接
export const getPreviewTemplateLink = (data: any) =>
  request.post('/erp/retailContractTemplateManage/getPreviewTemplateLink', data, jsonHeaderConfig)
// 产品添加合同模板
export const productConfigContractTemplate = (data: any) =>
  request.post(
    '/erp/web/youka/product_contract/productConfigContractTemplate',
    data,
    jsonHeaderConfig
  )
// 查询产品模板
export const selectContractConfig = (data: any) =>
  request.post('/erp/web/youka/product_contract/selectContractConfig', data)
// 代理列表
export const cooperationDownList = (data: any) =>
  request.post('/erp/retailOrganCooperationRelate/cooperationDown', data)
// 查询部门树（带数据权限）
export const permissionTreeGet = (data?: any) =>
  request.post('/admin/department/permission/tree', data)

// 添加代理
export const addProxyConfig = (data: any) =>
  request.post('/erp/web/youka/proxy_config/addProxyConfig', data, jsonHeaderConfig)
// 查詢代理
export const selectProxyConfig = (data: any) =>
  request.post('/erp/web/youka/proxy_config/selectProxyConfig', data)
// 分享
export const shareUrlGet = (data: any) =>
  request.post('/erp/web/youka/shop_product/shareMicroWebsite', data)
// 检查自定义域名
export const checkCustomBrand = (data: any) =>
  request.post('/erp/web/youka/shop_product/checkCustomBrand', data)
// 生成租户关联码
export const getAssociationCode = (params: any) => {
  return request.post(`/admin/tenant/authorization/code?id=${params}`, {}, jsonHeaderConfig)
}
// 获取产品方下拉列表
export const getProductBelong = (data: any) =>
  request.post('/erp/web/youka/shop_product/approveProductDataScope', data, jsonHeaderConfig)
// 风控配置
export const addConfig = (data: any) =>
  request.post('/erp/retailProductRisk/addConfig', data, jsonHeaderConfig)
export const queryConfig = (data: any) => request.post('/erp/retailProductRisk/queryConfig', data)
